export default {
  DocumentDirectoryPath: () => {},
  downloadFile: (data: any): any => {},
};
